import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgRelativeDate',
  standalone: false,
})
export class SGRelativeDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const date = new Date(value);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const inputDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes.toString().padStart(2, '0');
    const timeString = `${displayHours}:${displayMinutes}${ampm}`;

    if (inputDate.getTime() === today.getTime()) {
      return `Today ${timeString}`;
    } else if (inputDate.getTime() === yesterday.getTime()) {
      return `Yesterday ${timeString}`;
    } else {
      const daysDiff = Math.floor((today.getTime() - inputDate.getTime()) / (24 * 60 * 60 * 1000));
      if (daysDiff < 7) {
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return `${dayNames[date.getDay()]} ${timeString}`;
      } else {
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const day = date.getDate();
        return `${month} ${day} ${timeString}`;
      }
    }
  }
}
